export const dateTypes = [
  {
    label: "不设置",
    value: "None"
  },
  {
    label: "指定时间",
    value: "Custom"
  },
  {
    label: "系统当前时间",
    value: "Now"
  }
]

export const scanTypes = [
  {
    label: "二维码/条形码",
    value: "ALL"
  },
  {
    label: "二维码",
    value: "QR"
  },
  {
    label: "条形码",
    value: "BAR"
  }
]

export const timeTypes = [
  {
    label: "开始时间",
    value: "begin"
  },
  {
    label: "结束时间",
    value: "end"
  }
]

export const calcTypes = [
  {
    label: "数值计算",
    value: "NUM"
  },
  {
    label: "时长计算",
    value: "DATE"
  },
  {
    label: "距离计算",
    value: "LOCATION"
  },
  {
    label: "条件计算",
    value: "OPTION"
  }
]

export const rateTypes = [
  {
    label: "星星",
    value: "星星"
  },
  {
    label: "满意度",
    value: "满意度"
  }
]

export const checkStates = [
  {
    label: "选中",
    value: "选中"
  },
  {
    label: "未选中",
    value: "未选中"
  }
]

export const dateUnitTypes = [
  {
    label: "分",
    value: "分"
  },
  {
    label: "时",
    value: "时"
  },
  {
    label: "天",
    value: "天"
  },
  {
    label: "月",
    value: "月"
  },
  {
    label: "年",
    value: "年"
  }
]

export const locationUnitTypes = [
  {
    label: "米",
    value: "米"
  },
  {
    label: "千米",
    value: "千米"
  }
]

export const addressLevel = [
  {
    label: "省",
    value: 1
  },
  {
    label: "省-市",
    value: 2
  },
  {
    label: "省-市-区",
    value: 3
  },
  {
    label: "省-市-区-街道",
    value: 4
  }
]

export const departmentLevels = [
  {
    label: "一级部门",
    value: 1
  },
  {
    label: "二级部门",
    value: 2
  },
  {
    label: "三级部门",
    value: 4
  },
  {
    label: "四级部门",
    value: 5
  },
  {
    label: "所属部门",
    value: 3
  }
]

export const datePattern = [
  {
    label: "yyyyMMdd",
    type: "yyyyMMdd"
  },
  {
    label: "yyyyMM",
    type: "yyyyMM"
  },
  {
    label: "MMdd",
    type: "MMdd"
  },
  {
    label: "yyyy",
    type: "yyyy"
  }
]

export const hexList = [
  {
    label: "十进制（0-9)",
    value: 10
  },
  {
    label: "十六进制（0-9-A-F)",
    value: 16
  },
  {
    label: "三十四进制（0-9-A-Z）",
    value: 34
  }
]

export const timeTypeList = [
  {
    label: "年",
    value: "年",
    controlType: "year",
    displayFormat: "yyyy",
    djFormat: "YYYY"
  },
  {
    label: "半年度",
    value: "半年度",
    controlType: "datetime",
    displayFormat: "yyyy-MM-dd HH:mm:ss",
    djFormat: "YYYY-MM-DD HH:mm:ss"
  },
  {
    label: "季度",
    value: "季度",
    controlType: "datetime",
    displayFormat: "yyyy-MM-dd HH:mm:ss",
    djFormat: "YYYY-MM-DD HH:mm:ss"
  },
  {
    label: "年月",
    value: "年月",
    controlType: "month",
    displayFormat: "yyyy-MM",
    djFormat: "YYYY-MM"
  },
  {
    label: "年月日",
    value: "年月日",
    controlType: "date",
    displayFormat: "yyyy-MM-dd",
    djFormat: "YYYY-MM-DD"
  },
  {
    label: "年月日时分",
    value: "年月日时分",
    timeFormat: "HH:mm",
    displayFormat: "yyyy-MM-dd HH:mm",
    djFormat: "YYYY-MM-DD HH:mm",
    controlType: "datetime"
  },
  {
    label: "年月日时分秒",
    value: "年月日时分秒",
    timeFormat: "HH:mm:ss",
    displayFormat: "yyyy-MM-dd HH:mm:ss",
    djFormat: "YYYY-MM-DD HH:mm:ss",
    controlType: "datetime"
  }
]

export const timeUnitMap = {
  年: "year",
  半年度: "halfYear",
  季度: "quarter",
  年月: "month",
  年月日: "day",
  年月日时分: "minute",
  年月日时分秒: "second"
}

export const regionTypeList = [
  {
    label: "等于(=)",
    value: "equal"
  },
  {
    label: "开始于(>=)",
    value: "begin"
  },
  {
    label: "结束于(<=)",
    value: "end"
  },
  {
    label: "区间范围",
    value: "interval"
  },
  {
    label: "快捷区间",
    value: "fast-interval"
  }
]

export const regionTypeMap = {
  begin: "开始于",
  end: "结束于"
}

export const weekOptionList = [
  { label: "周一", value: 0 },
  { label: "周二", value: 1 },
  { label: "周三", value: 2 },
  { label: "周四", value: 3 },
  { label: "周五", value: 4 },
  { label: "周六", value: 5 },
  { label: "周日", value: 6 }
]

export const colorList = [
  "option-bg-red",
  "option-bg-orange",
  "option-bg-green",
  "option-bg-blue",
  "option-bg-purple",
  "option-bg-gray"
]

export const defaultOptions = [
  {
    value: "选项1",
    label: "选项1"
  },
  {
    value: "选项2",
    label: "选项2"
  },
  {
    value: "选项3",
    label: "选项3"
  }
]

export const commonExpressions = [
  {
    label: "字母",
    expression: "^[A-Za-z]*$"
  },
  {
    label: "字母数字",
    expression: "^[A-Za-z0-9]*$"
  },
  {
    label: "数字",
    expression: "^\\d*$"
  },
  {
    label: "大写字母",
    expression: "^[A-Z]*$"
  },
  {
    label: "小写字母",
    expression: "^[a-z]+$"
  },
  {
    label: "6个字母",
    expression: "^\\w{6}$"
  },
  {
    label: "6位数字",
    expression: "^\\d{6}$"
  },
  {
    label: "邮政编码",
    expression: "^\\d{4,6}$"
  },
  {
    label: "IP地址",
    expression: "^((2(5[0-5]|[0-4]\\d))|[0-1]?\\d{1,2})(.((2(5[0-5]|[0-4]\\d))|[0-1]?\\d{1,2})){3}$"
  },
  {
    label: "链接",
    expression: "^https?:\\/\\/\\w+\\.\\w+\\.\\w+.*$"
  },
  {
    label: "车牌号",
    expression: "^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]\\w{4,9}$"
  },
  {
    label: "身份证号",
    expression: "^\\d{17}[\\dX]$"
  },
  {
    label: "中国护照",
    expression:
      "(^[EeKkGgDdSsPpHh]\\d{8}$)|(^(([Ee][a-fA-F])|([DdSsPp][Ee])|([Kk][Jj])|([Mm][Aa])|(1[45]))\\d{7}$)"
  }
]

export const codeTypes = [
  {
    value: "all",
    label: "二维码/条形码"
  },
  {
    value: "qrCode",
    label: "二维码"
  },
  {
    value: "barCode",
    label: "条形码"
  }
]

export const codeTypeList = [
  {
    value: "message",
    label: "短信验证"
  },
  {
    value: "email",
    label: "邮件验证"
  }
]

export const waterMarkInfos = [
  {
    label: "系统字段",
    options: [
      {
        label: "当前用户",
        value: "curUser"
      },
      {
        label: "当前定位",
        value: "curLocation"
      },
      {
        label: "当前时间",
        value: "curTime"
      }
    ]
  }
]
